const ArrayUtils = {
    groupBy(array, key) {
        const result = {}
        array.forEach(item => {
            if (!result[item[key]]) {
                result[item[key]] = []
            }
            result[item[key]].push(item)
        })

        return result
    },

    // Turn enum into array
    EnumToArray(_enum) {
        let map = [] ;
        Object.keys(_enum).forEach(key => {
            map.push({Code:key, Name:_enum[key]})
            });
        return map;
    }
}

export default ArrayUtils;